module.exports = __webpack_public_path__ + "img/queren.aca93672.png";